__webpack_require__.p = "https://festatic.playgami.scopely.com/portal-calendar/v0_3_2/";